'use strict';

import * as _ from 'lodash-es';

(function () {
  angular
    .module('specsguardApp')
    .controller('AddNewAreaCtrl', AddNewAreaCtrl);

  AddNewAreaCtrl.$inject = ['$stateParams', 'Project', 'project', '$mdDialog',
    'shortCode', 'errorMessageService', 'ProjectDataservice', 'Labels', 'sg2ProjectService', 'sg2AreaService'];

  function AddNewAreaCtrl ($stateParams, Project, project, $mdDialog,
    shortCode, errorMessageService, ProjectDataservice, Labels, sg2ProjectService, sg2AreaService) {

    const vm = this;
    const buildingId = $stateParams.building_id || $stateParams.buildingId;

    const building = project.buildings.find(function (bldng) {
      return bldng._id.toString() === buildingId.toString();
    });

    vm.project = project;
    vm.building = building;
    vm.model = {};
    vm.area = { area: {} };

    vm.LABELS = Labels;

    vm.selected = {
      addAreaSheet: false
    };

    vm.model.selectedCluster = _.find(vm.building.clusters, { shortCode: shortCode });

    // Selecteer standaard de laatst aangemaakte ruimte template
    vm.model.selectedBasicArea = _.findLast(vm.project.basicAreas, {active: true});
    vm.model.quantity = 1;
    vm.model.surface = 20;
    vm.model.occupation = 1;

    vm.submitNewArea = () => {

      if (vm.form.$valid) {
        const functionality = vm.model.selectedBasicArea.functionality;

        vm.area._id = $stateParams.project_id;
        vm.area.paramId = vm.building._id;
        vm.area.versionId = vm.project.versionId;

        vm.area.clusterId = vm.model.selectedCluster._id;
        vm.area.area.basicArea = vm.model.selectedBasicArea._id;

        vm.area.area.name = vm.model.name;
        vm.area.area.surface = vm.model.surface;
        vm.area.area.quantity = vm.model.quantity;
        vm.area.area.height = vm.model.height;
        vm.area.area.occupation = vm.model.occupation;
        vm.area.area.comment = vm.model.comment;
        vm.area.area.functionality = functionality ? functionality : 1;
        vm.area.area.projectLevel = 5;

        // Create valid area for new api.
        const area = {
          ...vm.area.area,
          buildingId: vm.area.paramId,
          clusterId: vm.area.clusterId
        };

        sg2AreaService.addv1(area).subscribe(updatedProject => {
          errorMessageService.showSuccess(vm.LABELS.getLabel('areaadded'));

          // When creating a new area, the new area is recreated locally from response and known data.
          // This new area is send *directly* to ProjectService.addArea(), which is not the right
          // way to do. After migration, this block below should change to just AreaService.add(),
          // which handles all the logic, including the modal, the API call and the Project patching.
          const updatedBuildingId = $stateParams.building_id || $stateParams.buildingId;
          const updatedBuilding = updatedProject.buildings.find(b => b._id === updatedBuildingId);
          const updatedCluster = updatedBuilding.clusters.find(c => c.shortCode === shortCode);
          const updatedBuildingI = updatedProject.buildings.findIndex(b => b._id === updatedBuildingId);
          const updatedClusterI = updatedBuilding.clusters.findIndex(c => c.shortCode === shortCode);
          const updatedAreaI = updatedCluster.areas.findIndex(a => a._id === updatedCluster.areas[updatedCluster.areas.length - 1]._id);
          const newArea = {
            ...updatedCluster.areas[updatedCluster.areas.length - 1],
            clusterId: updatedCluster._id
          };
          updatedProject.buildings[updatedBuildingI].clusters[updatedClusterI].areas[updatedAreaI].clusterId = updatedCluster._id;

          // Send user to the add area sheet
          if (vm.selected.addAreaSheet) {
            vm.addAreaSheet(newArea);
          } else {
            ProjectDataservice.setProjectById(updatedProject._id, updatedProject);
            vm.cancel(updatedProject);
          }
        });

      }
    };

    // Send user to add sheet area
    vm.addAreaSheet = (newArea) => {
      const _projectId = $stateParams.project_id || $stateParams.projectId;
      const _buildingId = $stateParams.building_id || $stateParams.buildingId;

      const url = 'project/' + _projectId +
        '/building/' + _buildingId +
        '/areas/' + newArea._id + '/add-sheet';
      vm.cancel(null, url);
    };

    // Cancel dialog
    vm.cancel = (updatedProject, redirectUrl) => {
      $mdDialog.hide({updatedProject, redirectUrl});
    };
  }
})();
